import React from "react";
import Link from "gatsby-link";
import * as PropTypes from "prop-types";
import Header from '../components/Header/header';
import './news-post.css';

import news_image from '../images/covers/news.jpg';

const propTypes = {
  data: PropTypes.object.isRequired,
}

class NewsTemplate extends React.Component {
  render() {
    const news = this.props.data.contentfulNews;
    let date = new Date(news.createdAt);

    return (
      <div>
        <Header image={news_image} title={news.title} subtitle={"Published " + date.toLocaleDateString()}/>
        <div
          style={{
            display: `flex`,
            alignItems: `center`,
          }}
        >
        </div>
        <div className={"container news-post-container"}>
          <div className={"row"}>
            <div
              className={"col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10 news-post"}
              dangerouslySetInnerHTML={{
                __html: news.content.childMarkdownRemark.html,
              }}
            />
            <div className={"col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10 news-post-image"}>
              <img  src={news.image.file.url}/>
            </div>
          </div>

        </div>

      </div>
    )
  }
}

NewsTemplate.propTypes = propTypes;

export default NewsTemplate

export const pageQuery = graphql`
  query newsItemQuery($slug: String!) {
    contentfulNews(slug: { eq: $slug }) {
      title
      createdAt
      content {
        id
        content
        childMarkdownRemark {
          id
          html
        }
      }
      description {
        id
        description
      }
      image {
        id
        file {
          url
          fileName
          contentType
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/news-post.js